import { NavLink, useNavigate } from "react-router";
import Images from "../../../utility/imagePaths";
import { TechnologyType } from "../../../utility/types/generaTypes";
import { TECHNOLOGIES_TABS } from "../../../utility/utilityData";
import "./TechHeader.css";
type TechHeaderProps = {
  tech: TechnologyType;
};
const TechHeader = ({ tech }: TechHeaderProps) => {
  const navigate = useNavigate();

  const currentIndex = TECHNOLOGIES_TABS.findIndex(
    (item) => item.type === tech
  );
  const safeIndex = currentIndex === -1 ? 0 : currentIndex;

  const currentTech = TECHNOLOGIES_TABS[safeIndex];
  const prevTech =
    TECHNOLOGIES_TABS[
      safeIndex > 0 ? safeIndex - 1 : TECHNOLOGIES_TABS.length - 1
    ];
  const nextTech =
    TECHNOLOGIES_TABS[
      safeIndex < TECHNOLOGIES_TABS.length - 1 ? safeIndex + 1 : 0
    ];

  const handleLeftClick = () => {
    navigate(prevTech.to);
  };

  const handleRightClick = () => {
    navigate(nextTech.to);
  };
  return (
    <header className="appHeader_container">
      <div className="techHeader_subContainer">
        <h1 className="techHeaderLogo">
          <NavLink
            to="/"
            aria-label="JD SoftTech Home"
            className=" gradient_text"
          >
            JD SoftTech
          </NavLink>
        </h1>
        <div className="techHeader_rightContainer">
          <ArrowCard
            isLeft={true}
            label={prevTech.label}
            onclickArrow={handleLeftClick}
          />
          <p className="techHeader_midContainer">{currentTech.label}</p>
          <ArrowCard label={nextTech.label} onclickArrow={handleRightClick} />
        </div>
        <div className="techHeader_rightContainer_mobile">
          <p
            onClick={handleLeftClick}
            className="techHeader_rightContainer_mobile_commonBtnStyle"
          >
            <img
              src={Images.SVG_ARROW_BLUE}
              alt="arowleft"
              style={{ transform: "rotate(180deg)" }}
            />
          </p>
          <div
            onClick={handleRightClick}
            className="techHeader_rightContainer_mobile_commonBtnStyle nextHeadingBtn"
          >
            <p>{`${nextTech.label}`}</p>
            <img
              src={Images.SVG_ARROW_BLUE}
              alt="arowleft"
              onClick={handleLeftClick}
            />
          </div>
        </div>
      </div>
    </header>
  );
};
type ArrowCardProps = {
  isLeft?: boolean;
  label: string;
  onclickArrow: () => void;
};
const ArrowCard = ({ isLeft, label, onclickArrow }: ArrowCardProps) => {
  return (
    <div className="arrowCard_container" onClick={onclickArrow}>
      {isLeft && (
        <img
          src={Images.SVG_ARROW_RIGHT_GREY_ICON}
          alt="arowleft"
          className="arrowGrey"
          style={{ transform: "rotate(180deg)" }}
        />
      )}
      <p>{label}</p>
      {!isLeft && (
        <img
          src={Images.SVG_ARROW_RIGHT_GREY_ICON}
          alt="arowright"
          className="arrowGrey"
        />
      )}
    </div>
  );
};

export default TechHeader;
